import * as types from './mutation-types'

const mutations = {
  [types.SET_PLANT] (state, plant) {
    state.selectedPlant = plant
  }
}
export default mutations
